import {
  generateMarketPathname,
  InternationalMarket,
  MarketHandler,
  MarketHandlerFactory,
} from '@chewy/market-handler';

const getMarketHandler = (): MarketHandler => {
  return MarketHandlerFactory(process.env.CHEWY_MARKET ?? '');
};

export const marketHandler: MarketHandler = getMarketHandler();

export const isUSMarket = (): boolean =>
  marketHandler.market?.includes(InternationalMarket.enUS) ?? true;

export const getMarket = (): string => marketHandler.market ?? InternationalMarket.enUS;

/**
 * Generates the base path for the Next.js configuration.
 * @returns {string} The base path.
 */
export const getBasePath = (): string => marketHandler.subPath ?? '';

/**
 * Generates the asset prefix for the Next.js configuration.
 * @param {string} prodStaticAssetPath The production static asset path.
 * @returns {string} The asset prefix.
 */
export const getAssetPrefix = (prodStaticAssetPath: string): string =>
  generateMarketPathname(prodStaticAssetPath, marketHandler.market ?? InternationalMarket.enUS);

export const getUSMarketCode = (): string => {
  return InternationalMarket.enUS;
};

export const getSiteId = (): string => {
  return marketHandler.siteId ?? '10';
};
